import { inject, injectable } from "inversify";
import React from "react";
import { IpfModule } from "../..";
import { Constants } from "../../constants.generated";
import { TimeoutDuration } from "../../enums.generated";
import { EventConstants } from "../../EventConstants";
import { TYPES } from "../../ioc/types";
import { Message } from "../../models/app";
import { MessageService } from "../../services";
import { ServiceBase } from "../../services/ServiceBase";
import { MessageList, MessageListOptions } from "../components/MessageList";
import { ReactDOMProxy } from "../ReactDOMProxy";

/**
 * Messaging service, used to display Bootstrap toasts. Could later be extended to output Bootstrap alerts.
 */
@injectable()
export class BootstrapMessageService extends ServiceBase implements MessageService {

	private messageList: MessageListOptions | undefined;

	/**
	 * Initialises a new instance of the BootstrapMessageService class.
	 * @param ipfModule IPF module, used to store and retrieve temp data.
	 */
	public constructor(
		@inject(TYPES.IpfModule) private ipfModule: IpfModule
	) {
		super();
	}

	/**
	 * @inheritdoc
	 */
	public applyEffects(container: Element) {

		if (container) {

			this.applyMessageEffects(container);
			this.applyToastEffects(container);			
		}

		const messages = this.ipfModule.getData<Array<Message>>(Constants.DataKeyMessages);
		if (messages?.length > 0) {

			messages.forEach(message => {

				this.showMessage(message);
			});

			// clear the messages
			this.ipfModule.clearData(Constants.DataKeyMessages);
		}
	}

	/**
	 * @inheritdoc
	 */
	public clearMessages() {

		if (this.messageList?.clearMessages) {
			this.messageList.clearMessages();
		}
	}

	/**
	 * @inheritdoc
	 */
	public showMessage(message: Message) {

		const messageTarget = document.getElementById("message-target");

		if (messageTarget) {

			if (this.messageList) {

				if (this.messageList.addMessage)
					this.messageList.addMessage(message);
			}
			else {

				this.messageList = {
					messages: []
				} as MessageListOptions;

				ReactDOMProxy.renderStyled(
					<MessageList options={this.messageList} />,
					messageTarget
				);

				if (this.messageList.addMessage)
					this.messageList.addMessage(message);
			}
		}
	}

	private applyMessageEffects(container: Element) {

		$(".alert[data-dismiss-timeout],.toast[data-dismiss-timeout]", container).each((i, element) => {

			const jElement = $(element);

			if (jElement.data("dismiss-timeout")) {

				const timeout = jElement.data("dismiss-timeout") as TimeoutDuration;
				let duration: number;

				switch (timeout) {
					case TimeoutDuration.Fast:
						duration = 7500;
						break;
					case TimeoutDuration.Standard:
						duration = 15000;
						break;
					case TimeoutDuration.Slow:
						duration = 30000;
						break;
					default:
						duration = 0;
						break;
				}

				setTimeout(() => {
					jElement.fadeOut(() => {
						jElement.remove();
					});
				}, duration);
			}
		});
	}

	private applyToastEffects(container: Element) {

		$('.toast [data-dismiss]', container).off(EventConstants.click_ipf).on(EventConstants.click_ipf, event => {

			const jElement = $(event.currentTarget).closest(".toast");
			jElement.fadeOut(() => {
				jElement.remove();
			});
		});
	}
}